import { render, staticRenderFns } from "./anquan.vue?vue&type=template&id=06c17a6c&scoped=true&"
import script from "./anquan.vue?vue&type=script&lang=js&"
export * from "./anquan.vue?vue&type=script&lang=js&"
import style0 from "./anquan.vue?vue&type=style&index=0&id=06c17a6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c17a6c",
  null
  
)

export default component.exports